import React, { useCallback, useContext, useState } from "react";
import { useMount } from "hooks";
import { AppContext, FeatureFlagContext, UserContext } from "contexts";
import { Route, Switch } from "react-router-dom";
import { Path } from "enums";
import AppLoader from "components/commons/app-loader/app-loader";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "components/commons/sidebar/sidebar";
import MapPage from "./map.page";
import RecordingsPage from "./recordings.page";
import CampaignsPage from "./campaigns.page";
import SurveyBuilderPage from "./survey-builder.page";

const AuthorizedPage = () => {
  const { appState } = useContext(AppContext);
  const { setUserEmail } = useContext(FeatureFlagContext);
  const [user] = useState(() => {
    return {
      fullName: "Portal User",
      email: localStorage.getItem("email") || "portal.user@nexus.local",
    };
  });

  useMount(() => {
    setUserEmail(user.email);
  });

  const fetchUser = useCallback(async () => {
    return user;
  }, [user]);

  return (
    <UserContext.Provider value={{ user, fetchUser, loading: false }}>
      {appState?.loading || !user ? (
        <AppLoader />
      ) : (
        <>
          <Sidebar />
          <div
            style={{
              marginLeft: "288px",
              marginTop: "0",
              padding: "27px 36px",
              minWidth: "1170px",
              overflowX: "auto",
              minHeight: "100vh",
              backgroundColor: "#080f1d",
            }}
          >
            <Switch>
              <Route exact path={Path.Slash} component={CampaignsPage} />
              <Route exact path={Path.Map} component={MapPage} />
              <Route exact path={Path.Recordings} component={RecordingsPage} />
              <Route exact path={Path.Campaigns} component={CampaignsPage} />
              <Route exact path={Path.CampaignSurveyBuilder} component={SurveyBuilderPage} />
              <Route exact path="/:campaignCode" component={CampaignsPage} />
              <Redirect to={Path.Campaigns} />
            </Switch>
          </div>
        </>
      )}
    </UserContext.Provider>
  );
};

export default AuthorizedPage;
